import React, { useEffect, useState } from "react";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import { Container, Typography, Link } from "@mui/material"; 
import Logo from "../../components/Logo";
import OTPForm from "../../components/OTP";
import { motion } from "framer-motion";
import authentication from "../../services/AmplifyServices";
import "./style.css";
import { ErrorMessage } from "formik";

let easing = [0.6, -0.05, 0.01, 0.99];
const fadeInUp = {
  initial: {
    y: 60,
    opacity: 0,
    transition: { duration: 0.6, ease: easing },
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: easing,
    },
  },
};

const RESEND_COOLDOWN = 60;

function getSystemTheme() {
  try {
    const mq = window.matchMedia?.("(prefers-color-scheme: dark)");
    return mq && mq.matches ? "dark" : "light";
  } catch {
    return "light";
  }
}

function getInitialTheme() {
  try {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get("theme"); 
    if (fromUrl === "dark" || fromUrl === "light") return fromUrl;
    return getSystemTheme();
  } catch {
    return "light";
  }
}

function applyTheme(theme) {
  const next = theme === "dark" ? "dark" : "light";
  document.documentElement.setAttribute("data-theme", next);
}

const OTP = ({ setAuth }) => {
  const navigate = useNavigate();
  const location = useLocation();
  console.log(location.state);
  useEffect(() => {
    if (location.state === null) navigate("/login");

    const params = new URLSearchParams(window.location.search);
      const override = params.get("theme");
  
      applyTheme(getInitialTheme());
  
      if (!override || override === "system") {
        const mq = window.matchMedia?.("(prefers-color-scheme: dark)");
        const handler = (e) => applyTheme(e.matches ? "dark" : "light");
        if (mq) {
          if (mq.addEventListener) mq.addEventListener("change", handler);
          else if (mq.addListener) mq.addListener(handler); 
          return () => {
            if (mq.removeEventListener) mq.removeEventListener("change", handler);
            else if (mq.removeListener) mq.removeListener(handler);
          };
        }
      }
    // eslint-disable-next-line
  }, []);

  const handleResend = () => {
    console.log(location.state.email);
    authentication.signIn(location.state.email);
  };

    const [cooldown, setCooldown] = useState(() => {
    const until = Number(localStorage.getItem("otpResendUntil") || 0);
    const now = Date.now();
    return until > now ? Math.ceil((until - now) / 1000) : 0;
  });

    useEffect(() => {
      if (cooldown <= 0) return;
      const id = setInterval(() => {
        setCooldown((s) => {
          if (s <= 1) {
            clearInterval(id);
            return 0;
          }
          return s - 1;
        });
      }, 1000);
      return () => clearInterval(id);
    }, [cooldown]);

    const handleResendClick = async (e) => {
      e.preventDefault();
      if (cooldown > 0) return;
      try {
        await handleResend?.();
        const until = Date.now() + RESEND_COOLDOWN * 1000;
        localStorage.setItem("otpResendUntil", String(until));
        setCooldown(RESEND_COOLDOWN);
      } catch (err) {
        console.error(ErrorMessage);
    }
  };

  // eslint-disable-next-line
  const [isDark, setIsDark] = useState(
      document.documentElement.getAttribute("data-theme") === "dark"
  );

  useEffect(() => {
    const el = document.documentElement;
    const update = () =>
    setIsDark(el.getAttribute("data-theme") === "dark");

    update();
  
    const obs = new MutationObserver(update);
    obs.observe(el, { attributes: true, attributeFilter: ["data-theme"] });
  
    return () => obs.disconnect();
  }, []);

  return (
    <div className="root">
      <Container className="container" maxWidth="sm">
        <div className="card-content">
          <div className="sub-content">
            <div className="heading" component={motion.div} {...fadeInUp}>
              <Logo />
              <Typography sx={{
                color: isDark ? "#FFF" : "text.secondary",
                mb: 5 }}>
                Enter your one-time password sent to your email:{" "}
                {location.state && location.state.email}
              </Typography>
            </div>

            <OTPForm setAuth={setAuth} />

            <Typography
              component={motion.p}
              {...fadeInUp}
              variant="body2"
              align="center" 
              className="footer-text"
            >
              Code expires in 15 minutes. {" "}
              <Link
                variant="subtitle2"
                component={RouterLink}
                to=""
                state={location.state}
                onClick={handleResendClick}
                sx={{
                  color: cooldown > 0 ? "grey.500" : "#00C56E",
                  pointerEvents: cooldown > 0 ? "none" : "auto", // enable click
                  cursor: cooldown > 0 ? "default" : "pointer",
                  ml: 0.5,
                }}
              >
              {cooldown > 0 ? `Resend (${cooldown}s)` : "Resend"}
              </Link>
            </Typography>

            <br></br>

            <Typography
              component={motion.p}
              {...fadeInUp}
              variant="body2"
              align="center" 
              className="footer-text"
            >
              <i><b style={{color: "red", textDecoration: "underline"}}>IMPORTANT</b>: </i><i>If you don't see the email, check your spam folder and mark it “<b>Not Spam</b>”.</i>
            </Typography>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default OTP;
